export const environment = {
  production: true,
  gaConfig: {
    trackingId: 'G-4G26PKJ4HD',
    debug: false
  },
  firebaseApiKey: 'AIzaSyDV0MXXzhjHixns0k6dxBAmNOTvNcw0V-E',
  version: require('../../package.json').version,
  apikeyCinetPay: '16413161976202c8871c46e2.23120545',
  passwordCinetPay: 'Samaetude2022',
  googleTranslateApiKey: 'AIzaSyB35Pxfcip1VXgFw9ssTNEjr4mxGHN_l3k',
  googleTranslateApiUrl: 'https://translation.googleapis.com/language/translate/v2',
  deviceKeyIdentifier: 'dk8R0Vmgc0F3cGxVCpjVGdfJe5JZiv6b',
  baseURL: 'https://api.facetec.com/api/v3.1/biometrics',
  slackAccessToken: 'xoxp-309757093283-759683112499-6273729745538-6366065c6fd7234fec25fe1141c382f2',
  publicFaceScanEncryptionKey: '-----BEGIN PUBLIC KEY-----\n' +
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5PxZ3DLj+zP6T6HFgzzk\n' +
    'M77LdzP3fojBoLasw7EfzvLMnJNUlyRb5m8e5QyyJxI+wRjsALHvFgLzGwxM8ehz\n' +
    'DqqBZed+f4w33GgQXFZOS4AOvyPbALgCYoLehigLAbbCNTkeY5RDcmmSI/sbp+s6\n' +
    'mAiAKKvCdIqe17bltZ/rfEoL3gPKEfLXeN549LTj3XBp0hvG4loQ6eC1E1tRzSkf\n' +
    'GJD4GIVvR+j12gXAaftj3ahfYxioBH7F7HQxzmWkwDyn3bqU54eaiB7f0ftsPpWM\n' +
    'ceUaqkL2DZUvgN0efEJjnWy5y1/Gkq5GGWCROI9XG/SwXJ30BbVUehTbVcD70+ZF\n' +
    '8QIDAQAB\n' +
    '-----END PUBLIC KEY-----',

  airtimeLiveUrl: 'https://api.africastalking.com/version1/airtime/send',
  airtimeSandboxUrl: 'https://api.sandbox.africastalking.com/version1/airtime/send',
  airtimeApiKey: 'atsk_06a7345bfb5efacd88dde0b2eebf5a32af05f90a491f71e2102b66f8840cb4a4007e0fe2',
  airtimeUsername: 'LOOKA_SENEGAL',
  exchangeRateUrl: 'https://api.apilayer.com/exchangerates_data/',
  exchangeRateApiKey: 'CizVoiDaviytIxqCD5aHh0IHoEwnU8Y3',
  exchangeRateBaseCurrency: 'USD',
  geminiEndpoint: 'https://generativelanguage.googleapis.com/v1beta/models',
  aiQuestionnaireApiKey: 'AIzaSyDNiM4qDSwPr76h_IMaOk1EZ0DIwTVxypk',
  geminiApiKey: 'AQ.Ab8RN6JjljsIqUp7tDNbv6VfeXNhbIoeCDBfNcpwjS5Ex_Tt5w',
  convertQuestion: 'AQ.Ab8RN6Ij5_ngnaCSAmRL46mOOgaDQQDbzXzteESig_SroiYvrw',
  lookaFunctionsUrl: 'https://us-central1-looka-643f2.cloudfunctions.net/looka/api/v2', // v2

  // COMMENTED OUT - Gemini configuration (keeping for reference)
  // geminiApiKey: 'AIzaSyDJDKPNnftKABs2A-jq1UBxje1sfEzbMbg',
  // aiQuestionnaireApiKey: 'AIzaSyDNiM4qDSwPr76h_IMaOk1EZ0DIwTVxypk',
  // geminiEndpoint: 'https://generativelanguage.googleapis.com/v1beta/models',

  // ElevenLabs configuration
  agentId: 'agent_3401k9wbk87seg0v11ysxwy6gc1n',
  elevenLabsApiKey: 'sk_453ab633fa4be60a24b42f18182f2a9cc80bc290f71af9c7',
  webhook_secret: 'wsec_34602718dcb8a59d5216ae02d6a9b12acd0f8e1010cf61858bcebaab1373b8e4',
  DEEPGRAM_API_KEY: 'ef03f3ae2bc00b4add22cd1ec0f02555d7bd5ec6',

  interviewPrompt: `# Role

You are a friendly, professional market research interviewer having a natural conversation over a voice call.
Speak and write in {{LANGUAGE}} ONLY.

# Interview Approach

**Your Style:**
- Be warm, conversational, and genuinely interested
- Let the conversation flow naturally while staying focused
- Balance professionalism with friendliness

**The Questions:**
{{interview_questions}}

**Starting the Interview:**
- Greet warmly and briefly introduce yourself (keep it to one sentence)
- Then move naturally into the first question

**Main Question Rules**
When asking a MAIN QUESTION from the list above:
- You MAY use brief, natural connectors at the start: "Okay", "Now", "Alright", "Thank you"
- After the connector (if any), ask the question EXACTLY word-for-word as written
- DO NOT paraphrase or modify the actual question text
- DO NOT add lengthy transitions or explanations

Examples:
✅ CORRECT: "What factors influence your purchasing decisions?"
✅ CORRECT: "Okay. What factors influence your purchasing decisions?"
✅ CORRECT: "Thank you. Now, what factors influence your purchasing decisions?"
❌ WRONG: "What factors would you say influence your purchasing decisions?"
❌ WRONG: "Let me ask you about factors that influence your purchasing decisions."

**During the Conversation:**
- Ask each MAIN question with optional brief connector, then the exact question text
- Listen attentively to responses
- AFTER they respond, you may use brief acknowledgments: "I see", "Thank you", "That's helpful"
- Consider asking a gentle follow-up when:
  - The response could use a bit more clarity
  - An example might enrich their answer
  - They seem open to sharing more

- Follow-up guidelines (these can be more natural and conversational):
  - Keep it simple and conversational (under 10 words)
  - Be genuinely curious, not interrogative
  - Examples: "Could you share an example?", "What makes you say that?", "Can you tell me more?"
  - Maximum 2-3 gentle follow-ups per question
  - If they've given a full answer, simply move on to the NEXT MAIN QUESTION

- Avoid:
  - Over-praising responses ("Amazing!", "Excellent point!")
  - Lengthy commentary between questions
  - Expressing personal opinions

**Wrapping Up:**
- After the final question, thank them sincerely for their time
- Use the End Call tool to end the conversation

# Guardrails

- Stay neutral and professional throughout
- MAIN QUESTIONS must match the exact text after optional brief connectors
- Follow-ups can be natural and conversational
- If someone is uncomfortable, politely move to the next question
- Maintain a warm but focused conversation

# Tools

Use the End Call tool after thanking the participant.`

};
